import { http, type HttpOptions } from './httpClient'
import type {
  CreateInvitationRequest,
  Paginated,
  RespondInvitationRequest,
  WorkspaceInvitation,
} from './types'

export interface InvitationListParams {
  limit?: number
  offset?: number
}

export const invitationApi = {
  listForWorkspace: (
    workspaceId: number,
    params: InvitationListParams = {},
    opts?: HttpOptions,
  ) =>
    http.get<Paginated<WorkspaceInvitation>>(`/api/workspaces/${workspaceId}/invitations/`, {
      ...opts,
      query: { ...opts?.query, ...params },
    }),

  create: (workspaceId: number, body: CreateInvitationRequest, opts?: HttpOptions) =>
    http.post<WorkspaceInvitation, CreateInvitationRequest>(
      `/api/workspaces/${workspaceId}/invitations/`,
      body,
      opts,
    ),

  cancel: (workspaceId: number, invitationId: number, opts?: HttpOptions) =>
    http.patch<WorkspaceInvitation, { is_active: false }>(
      `/api/workspaces/${workspaceId}/invitations/${invitationId}/`,
      { is_active: false },
      opts,
    ),

  resend: (workspaceId: number, invitationId: number, opts?: HttpOptions) =>
    http.post<WorkspaceInvitation, Record<string, never>>(
      `/api/workspaces/${workspaceId}/invitations/${invitationId}/resend/`,
      {},
      opts,
    ),

  myPending: (opts?: HttpOptions) =>
    http.get<Paginated<WorkspaceInvitation>>('/api/me/invitations/', opts),

  respond: (invitationId: number, body: RespondInvitationRequest, opts?: HttpOptions) =>
    http.post<WorkspaceInvitation, RespondInvitationRequest>(
      `/api/me/invitations/${invitationId}/respond/`,
      body,
      opts,
    ),
}
